<template>
    <div style="position:relative; top:190px;">

        <content-header
            icona="fas fa-check"
            :titolo="'Benvenuto ' + nominativo"
        ></content-header>

        
        <div class="card sn-card-contenuto">
            <div class="card-body">

                <!-- ****** GRIGLIA ****** -->
                <!-- ********************* -->
                <template v-if="mostraGriglia">
                    <h5>Quiz a tua disposizione</h5>

                    <button type="button" class="btn btn-dark" @click="GetQuestionariDisponibili()">
                        <i class="fas fa-sync"></i>&nbsp;
                    </button>&nbsp;

                    <br /><br />

                    <!-- **** GRIGLIA QUESTIOANRI **** -->
                    <div v-for="(q, i) in dtQuestionari" :key="i" class="card mb-3">
                        <div class="card-body">
                            <div class="d-flex flex-column flex-md-row justify-content-between align-items-start">
                            <!-- Colonna principale -->
                            <div>
                                <h5 class="mb-1">{{ q.cor_titolo }}</h5>
                                <p class="mb-1">Tipo: <span class=" text-success">{{ q.qti_descrizione }}</span>&nbsp;
                                    <i class="fas fa-graduation-cap fa-fw fa-sm text-primary" v-if="q.qti_descrizione.indexOf('finale') >= 0"></i>
                                    <i class="fas fa-door-open fa-fw fa-sm text-warning" v-if="q.qti_descrizione.indexOf('ingresso') >= 0"></i>
                                </p>
                                <p class="mb-1 text-muted">Corso: {{ q.que_nome }}</p>
                                <p class="mb-1 text-muted">Date svolgimento:</p>
                                <p class="mb-0">
                                Dal {{ q.cor_dta_inizio }}<br />
                                Al {{ q.cor_dta_fine }}
                                </p>
                            </div>

                            <!-- Azioni -->
                            <div class="mt-3 mt-md-0">
                                <button type="button" class="btn btn-sm btn-success" title="Inizia test" @click="StartTest(q.que_idq, q.cor_id)">
                                    <i class="fas fa-play-circle fa-fw"></i> Inizia test
                                </button>
                            </div>
                            </div>
                        </div>
                    </div>

                </template>

                
                <!-- ****** TEST ****** -->
                <!-- ****************** -->
                <template v-if="mostraTest">
                    <em>ATTENZIONE! Durante il test non chiudere la pagina o cliccare sul pulsante "indietro" del browser pena il mancato salvataggio dei risultati del test in corso! Inoltre, una volta iniziato il test non sarà possibile ripeterlo senza l'intervento dell'amministratore.</em>

                    <template v-for="q in dtQuiz" :key="q.que_idq">

                        <br /><br />
                        <h4>{{ q.que_nome }}</h4>
                        
                        <p v-if="q.que_testo != ''">{{ q.que_testo }}</p>

                        <div class="card mb-3" v-for="d, i in q.domande" :key="i">  
                            <div class="card-header">
                                <strong>{{i+1}}.</strong> {{ d.qdo_testo }}
                            </div>
                            <div class="card-body">
                                <ul style="list-style-type: none;">
                                    <li class="mb-2" v-for="r, ri in d.risposte" :key="ri">
                                        <input type="radio" class="form-check-input" :name="'ris_' + i" :checked="r.selected" @click="selectAnswer(d.risposte, ri)" >&nbsp;
                                        {{ r.qri_testo }}
                                    </li>
                                </ul>
                            </div>

                        </div>

                        <br /><br />
                        <em>Rispondi a tutte le domande per concludere il test e visionare il risultato.</em><br />
                        <strong>Risposte date {{ CalcolaRisposte() }} su {{q.que_domande}}</strong>

                        <br /><br />
                        <button class="btn btn-success" v-if="CalcolaRisposte() == q.que_domande" @click="TerminaTest()">Concludi il test</button>


                    </template>

                    

                    
                    
                </template>

                <!-- ****** RISULTATO ****** -->
                <!-- *********************** -->
                <template v-if="mostraRisultato">

                    <div class="d-flex flex-column justify-content-center text-center">
                        <h3>Risultato</h3>
                        <div class="mt-3" v-if="dtEsito[0] == 'OK'">
                            <i class="fas fa-check-circle text-success fa-4x"></i><br /><br />
                            <p><strong>Test superato</strong></p>
                            <p>Punteggio {{dtEsito[1]}} su {{dtEsito[2]}}</p>
                            <br />
                            <p>E' possibile chiudere la pagina.</p>

                        </div>
                        <div class="mt-3"  v-if="dtEsito[0] == 'KO'">
                            <i class="fas fa-times-circle text-danger fa-4x"></i><br /><br />
                            <p><strong>Test fallito</strong></p>
                            <p>Punteggio {{dtEsito[1]}} su {{dtEsito[2]}}</p>
                            <br />
                            <p>E' possibile chiudere la pagina.</p>

                        </div>
                    </div>
                    

                </template>
                
                

            </div>
        </div>


    </div>
  
    

   
    
</template>

<script>
import ContentHeader from '@/components/layout/ContentHeader.vue';

export default {
    name: 'DashboardView',
    components: {
        ContentHeader
    },
    inject: ['cfg'],
    data: function() {
        return {
            dtQuestionari: [],
            dtQuiz: [],
            dtEsito: [],

            nominativo: "",

            


            mostraGriglia: true,
            mostraTest: false,
            mostraRisultato: false,

            
        }
    },
    methods: {
        GetQuestionariDisponibili() {
            //Carica lista elementi
            this.$store.commit('Messaggio', {parms: [true, ['Caricamento in corso...'], 'alert alert-info', 'fa-spinner', true, 0]});
            fetch(this.cfg.apisrv + "/api/ExecQuiz/GetQuestionariDisponibili?token=" + this.$store.state.UserInfo.token)
                .then(response => response.json())
                .then(obj => {
                    this.dtQuestionari = obj;

                    this.$store.commit('Messaggio', {parms: [true, ['Fatto. '], 'alert alert-success', 'fa-check', false, 2000]});
                });
        },

        StartTest(idq, idCor) {
            if(confirm("Vuoi davvero iniziare il test? ")) {
                this.mostraGriglia = false;
                this.mostraTest = true;
                this.mostraRisultato = false;

                //Carica questionario
                this.$store.commit('Messaggio', {parms: [true, ['Preparazione del test in corso...'], 'alert alert-info', 'fa-spinner', true, 0]});
                fetch(this.cfg.apisrv + "/api/ExecQuiz/GetQuestionario?token=" + this.$store.state.UserInfo.token + "&idq=" + idq + "&idCor=" + idCor)
                    .then(response => response.json())
                    .then(obj => {
                        this.dtQuiz = obj;
                        this.dtQuiz[0].dtaInizio = new Date();

                        this.$store.commit('Messaggio', {parms: [true, ['Questionario caricato. '], 'alert alert-success', 'fa-check', false, 2000]});
                });

            }
        },
        TerminaTest() {
            let oSubmit = [];
            oSubmit = this.dtQuiz;
            oSubmit[0].token = this.$store.state.UserInfo.token;

            this.$store.commit('Messaggio', {parms: [true, ['Salvataggio in corso...'], 'alert alert-info', 'fa-spinner', true, 0]});
            fetch(this.cfg.apisrv + "/api/ExecQuiz/TerminaTest", {
                "method": "POST",
                "headers": {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                "body": JSON.stringify(oSubmit)
            }).then(response => response.json())
                .then(obj => {
                    if (obj.status == "OK") {
                        this.$store.commit('Messaggio', {parms: [true, ['Salvataggio effettuato.'], 'alert alert-success', 'fa-check', false, 2000]});

                        this.mostraGriglia = false;
                        this.mostraTest = false;
                        this.mostraRisultato = true; 

                        this.dtEsito = obj.dati;

                     
                     
                    }
                    else {
                        //this.$store.commit('Messaggio', {parms: [true, obj.dati, 'alert alert-warning', 'fa-times', false, 3000]});

                    }
                });

        },

        selectAnswer(risposte, selectedIndex) {
            risposte.forEach((r, index) => {
                r.selected = index === selectedIndex;
            });
        },

        CalcolaRisposte() {

            let cntRisp = 0;
            this.dtQuiz.forEach(q => {
                q.domande.forEach(d => {
                    d.risposte.forEach(r => {
                        if(r.selected) cntRisp++;
                    })
                })
            })

            return cntRisp;
        },


       

    },
    mounted: function() {
        if(this.$store.state.UserInfo.token == '') this.$router.push("/");

        this.nominativo = this.$store.state.UserInfo.cognome + ' ' + this.$store.state.UserInfo.nome;

        this.GetQuestionariDisponibili();
    }
}
</script>